import { WithdrawStep } from '../components/WithdrawStep';
import { WithdrawStepV2 } from '../components/WithdrawStepV2';
import { ReviewStep } from '../components/ReviewStep';
import { WithdrawCompletedStep } from '../components/WithdrawCompletedStep';

export enum EProductWithdrawSteps {
  WITHDRAW,
  WITHDRAWV2,
  REVIEW,
  CONCLUSION
}

export const ProductWithdrawComponents = {
  [EProductWithdrawSteps.WITHDRAW]: WithdrawStep,
  [EProductWithdrawSteps.WITHDRAWV2]: WithdrawStepV2,
  [EProductWithdrawSteps.REVIEW]: ReviewStep,
  [EProductWithdrawSteps.CONCLUSION]: WithdrawCompletedStep
};
